// Stamped by scripts/write-release.mjs when GITHUB_SHA or .preview-client-id is
// present. These committed values are the local and unit-test defaults.
// releaseVersion matches the Datadog sourcemap upload (`github.sha`).
// previewClientId is the ephemeral Sirius client for a PR preview.
export const releaseVersion = '06055aa253d906f8b793d0558cd21c4be55156f7';
export const previewClientId = 'future-room-preview-future-room-3-ro2kqxod';
